import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'

Vue.use(Vuex)

// 应用初始状态
const state = {
    count: 10,
    routerObj: null,
    menuLockStatus: '0',
    oneTimePwFlag: '0',
    mailNum: 0,
    hostname: ''
}

// 定义所需的 mutations
const mutations = {
    // お知らせ未確認件数变更
    mailNum(state, newState) {
        state.mailNum = newState < 0 ? 0 : newState
    },

    increment(state, newState) {
        state.menuLockStatus = newState
    },

    // pw变更
    passwordUpdate(state, newState) {
        state.oneTimePwFlag = newState
    },

    INCREMENT(state) {
        state.count++
    },
    DECREMENT(state) {
        state.count--
    },
    set_router(state, routerObj) {
        state.routerObj = routerObj
    },
    set_hostname(state, hostname) {
        state.hostname = hostname
    }
}

// 创建 store 实例
export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/vuex/store.js